import favoritesStore from '../store/store';
import { addToOrderedFavoriteIdList } from '../actions/v2/loadOutlookFavorites';
import { mutator } from 'satcheljs';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { getIndexerValueForMailboxInfo } from 'owa-client-types';

export default mutator(addToOrderedFavoriteIdList, actionMessage => {
    const favoriteData = actionMessage.favoriteData;
    const key = getIndexerValueForMailboxInfo(
        favoriteData?.mailboxInfo ?? getModuleContextMailboxInfo()
    );
    favoritesStore.favoriteTreeData
        .get(key)
        ?.orderedOutlookFavoritesIds.push(favoriteData.favoriteId);
});
